import ownerDocument from './owner-document';

var getDocument = function (element) { return ownerDocument(element).documentElement; };

export default getDocument;



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/document.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/document.js
// module chunks = 3